// extracted by mini-css-extract-plugin
export default {"multiSelect":"multi-select_multiSelect__Mjpfk","withLabel":"multi-select_withLabel__nIXUP","MuiInput-root":"multi-select_MuiInput-root__RUoPU"};